export default __webpack_public_path__ + "static/media/profile-2.35ac0bb0.png";